module.exports = __webpack_public_path__ + "static/media/VectorSMS.ae131381.svg";